import { render } from "./LivraisonPointRelais.vue?vue&type=template&id=0d8f9dfa&scoped=true"
import script from "./LivraisonPointRelais.vue?vue&type=script&lang=js"
export * from "./LivraisonPointRelais.vue?vue&type=script&lang=js"

import "./LivraisonPointRelais.vue?vue&type=style&index=0&id=0d8f9dfa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d8f9dfa"]])

export default __exports__